import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import {
    TimeSeriesDynamicSelectionComponent,
} from '@backoffice-frontend/time-series-identifier/api';
import { TimeSeriesIdentifierInputForm } from '@backoffice-frontend/time-series-identifier/domain';
import type { TimeSeriesAnalysisIdentifierDataLocalized, TimeSeriesInput } from '@clean-code/models';
import { BaseWidgetTypeConfigComponent } from '@clean-code/shared/dashboard/widget/api-widget';
import { PatchFormGroupValuesDirective } from '@clean-code/shared/directives/ui-form';
import { Observable } from 'rxjs';
@Component({
  selector: 'dashboard-market-overview-widget-config',
  templateUrl: './market-overview-widget-config.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    PatchFormGroupValuesDirective,
    TimeSeriesDynamicSelectionComponent,
  ],
})
export class MarketOverviewWidgetConfigComponent extends BaseWidgetTypeConfigComponent<TimeSeriesInput> {
  public timeSeries$: Observable<TimeSeriesAnalysisIdentifierDataLocalized[]>;

  override form = new UntypedFormGroup({
    identifier: new TimeSeriesIdentifierInputForm(),
  });

  public close() {
    //TODO: dashboard state
    // this.callback.next();
  }
}
